var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWavedown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "wave",
    style: {
      transform: "rotate(180deg)",
      transition: "0.3s"
    },
    viewBox: "0 0 1440 150",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sw-gradient-0",
    x1: 0,
    x2: 0,
    y1: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(255, 111, 97, 1)",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(255, 179, 11, 1)",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      transform: "translate(0, 0px)",
      opacity: 1
    },
    fill: "url(#sw-gradient-0)",
    d: "M0,105L10.9,110C21.8,115,44,125,65,115C87.3,105,109,75,131,65C152.7,55,175,65,196,70C218.2,75,240,75,262,65C283.6,55,305,35,327,42.5C349.1,50,371,85,393,90C414.5,95,436,70,458,65C480,60,502,75,524,85C545.5,95,567,100,589,95C610.9,90,633,75,655,72.5C676.4,70,698,80,720,77.5C741.8,75,764,60,785,65C807.3,70,829,95,851,95C872.7,95,895,70,916,57.5C938.2,45,960,45,982,47.5C1003.6,50,1025,55,1047,50C1069.1,45,1091,30,1113,22.5C1134.5,15,1156,15,1178,15C1200,15,1222,15,1244,32.5C1265.5,50,1287,85,1309,85C1330.9,85,1353,50,1375,35C1396.4,20,1418,25,1440,45C1461.8,65,1484,100,1505,95C1527.3,90,1549,45,1560,22.5L1570.9,0L1570.9,150L1560,150C1549.1,150,1527,150,1505,150C1483.6,150,1462,150,1440,150C1418.2,150,1396,150,1375,150C1352.7,150,1331,150,1309,150C1287.3,150,1265,150,1244,150C1221.8,150,1200,150,1178,150C1156.4,150,1135,150,1113,150C1090.9,150,1069,150,1047,150C1025.5,150,1004,150,982,150C960,150,938,150,916,150C894.5,150,873,150,851,150C829.1,150,807,150,785,150C763.6,150,742,150,720,150C698.2,150,676,150,655,150C632.7,150,611,150,589,150C567.3,150,545,150,524,150C501.8,150,480,150,458,150C436.4,150,415,150,393,150C370.9,150,349,150,327,150C305.5,150,284,150,262,150C240,150,218,150,196,150C174.5,150,153,150,131,150C109.1,150,87,150,65,150C43.6,150,22,150,11,150L0,150Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavedown);
export default __webpack_public_path__ + "static/media/wavedown.60cffa9026e657f9670f23c4f6a7742a.svg";
export { ForwardRef as ReactComponent };